<template>
  <div class="special-main pcdetails">
    <el-backtop target=".pcdetails"></el-backtop>
    <div class="pchome-headerabo">
      <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
    </div>
    <position-bar :productc_nav="productc_nav" :positionNav="positionNav">
    </position-bar>
<!--    <div class="special-body">-->
<!--      <div class="banner-container" ref="bannerContainerRef">-->
<!--        <div class="banner" ref="bannerRef">-->
<!--          <div class="banner-logo">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260111/b2854b2be4cd927e35478aa0f52897b8.jpg" alt="">-->
<!--          </div>-->
<!--          <p class="banner-title">-->
<!--            让预备更智能-->
<!--          </p>-->
<!--          <div class="banner-product">-->
<!--            <img @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/a75ef6a5e9017736414456a651e30bfa.png" alt="">-->
<!--          </div>-->
<!--          &lt;!&ndash;          <img  @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251213/c6a240bdcae136014d3cc484e3d404b0.jpg" alt="">&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="preview-video-container" ref="previewVideoContainerRef">-->
<!--          <div class="preview-video-box" ref="previewVideoBoxRef">-->
<!--          </div>-->
<!--          <div class="preview-video-text" ref="previewVideoTextRef">-->
<!--            <h4>扭矩更稳</h4>-->
<!--            <h4>测量更准</h4>-->
<!--            <h4>锉序列自定义</h4>-->
<!--            <h4>操作更自由</h4>-->
<!--            <endo-button @onclick="openVideoModal(videoList[0].previewVideo)"></endo-button>-->
<!--          </div>-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="background-video"-->
<!--                 :ref="videoList[0].ref"-->
<!--                 :src="videoList[0].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--          ></video>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-product-desc">-->
<!--        <div class="product-logo">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/87e903851c3d897212cbc769f7cbf820.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-logo-text">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/67e1d823677d4b4c5aff4dcee4305af0.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-image">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/53bcd6f9b799a2382480c45080755cbe.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-special-title">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>智能扭矩 预备更自如</h5>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="product-detail-text1"  style="text-align: center;">-->
<!--          <p class="txt">在连续锉模式下</p>-->
<!--          <p class="txt">可实时分析牙本质阻力</p>-->
<!--          <p class="txt">自动匹配根管不同区域所需扭矩</p>-->
<!--          <p class="txt">在确保高效切削的同时</p>-->
<!--          <p class="txt">有效降低扭转疲劳与锉断风险</p>-->
<!--          <endo-button @onclick="openVideoModal(videoList[1].previewVideo)"></endo-button>-->
<!--        </div>-->

<!--        <div class="product-video-container">-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[1].progress" :isPlaying="videoList[1].playing" index="1" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="product-video"-->
<!--                 :ref="videoList[1].ref"-->
<!--                 :src="videoList[1].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--          ></video>-->
<!--        </div>-->

<!--        <div class="product-detail-text1 product-detail-text2">-->
<!--          <p class="txt">马达持续监测扭矩并自动设定安全阈值</p>-->
<!--          <p class="txt">扭矩超限时自动切换往复模式</p>-->
<!--          <p class="txt">不同锉型无需单独设定扭矩</p>-->
<!--        </div>-->

<!--        <div class="step-list">-->
<!--          <div class="step-item">-->
<!--            <video class="step-video-1"-->
<!--                   :ref="videoList[2].ref"-->
<!--                   :src="videoList[2].video"-->
<!--                   muted-->
<!--                   playsinline-->
<!--                   loop-->
<!--            ></video>-->
<!--            <div class="step-video-txt">-->
<!--              <div class="step-video-title">-->
<!--                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">-->
<!--                <h5>步骤 1</h5>-->
<!--              </div>-->
<!--              <p class="txt-big mt-15">2<span class="txt-middle">s</span></p>-->
<!--              <p class="txt-small">检测扭矩</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step-item">-->
<!--            <video class="step-video-2"-->
<!--                   :ref="videoList[3].ref"-->
<!--                   :src="videoList[3].video"-->
<!--                   muted-->
<!--                   playsinline-->
<!--                   loop-->
<!--            ></video>-->
<!--            <div class="step-video-txt">-->
<!--              <div class="step-video-title">-->
<!--                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">-->
<!--                <h5>步骤 2</h5>-->
<!--              </div>-->
<!--              <p class="txt-small mt-25">自动设置</p>-->
<!--              <p class="txt-small">理想扭矩</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step-item">-->
<!--            <video class="step-video-3"-->
<!--                   :ref="videoList[4].ref"-->
<!--                   :src="videoList[4].video"-->
<!--                   muted-->
<!--                   playsinline-->
<!--                   loop-->
<!--            ></video>-->
<!--            <div class="step-video-txt">-->
<!--              <div class="step-video-title">-->
<!--                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">-->
<!--                <h5>步骤 3</h5>-->
<!--              </div>-->
<!--              <p class="txt-small mt-25">超过则往复</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-product-suit section-product-desc">-->
<!--        <div class="product-logo">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/fd75dc0a2eb9cc522f4458e6482640d0.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-logo-text">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/ef9dacf873710fd3a4777acd9297cc29.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-special-title">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>稳定测量 更准更清晰</h5>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="product-detail-text1"  style="text-align: center;">-->
<!--          <p class="txt">电子测量若不稳定容易造成根尖定位误差</p>-->
<!--          <p class="txt">ClearSignal™ 技术可实时评估信号稳定性</p>-->
<!--          <p class="txt">帮助判断连接是否可靠</p>-->
<!--          <p class="txt">提升根尖测量的准确性</p>-->
<!--          <endo-button @onclick="openVideoModal(videoList[5].previewVideo)"></endo-button>-->
<!--        </div>-->

<!--        <div class="g-preview-video-container product-video-container">-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[5].progress" :isPlaying="videoList[5].playing" index="5" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="g-preview-video product-video"-->
<!--                 :ref="videoList[5].ref"-->
<!--                 :src="videoList[5].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--          ></video>-->
<!--        </div>-->

<!--        <div class="product-detail-text1 product-detail-text2 product-detail-text3">-->
<!--          <p class="txt">系统可同步显示电子信号稳定性</p>-->
<!--          <p class="txt">轻触仪表盘即可获得屏幕提示与引导</p>-->
<!--        </div>-->

<!--        <div class="g-mode-video-container product-video-container">-->
<!--          <video class="g-mode-video product-video"-->
<!--                 :ref="videoList[6].ref"-->
<!--                 :src="videoList[6].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--                 @canplaythrough="onModeVideoLoaded"-->
<!--          ></video>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="improved-container" ref="improvedContainerRef">-->
<!--        <div class="improved-banner" >-->
<!--          <img @load="onImprovedBanner" :style="{top: -improvedBannerTop + 'px'}" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260118/aee5559d4caf2d8c114ba48a292657b5.jpg" alt="">-->
<!--&lt;!&ndash;          <div style="background-image: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260118/aee5559d4caf2d8c114ba48a292657b5.jpg');width: 100%;height: 100%;"></div>&ndash;&gt;-->
<!--          <div class="blur-after"></div>-->
<!--          <div class="improved-background"></div>-->
<!--          <div class="improved-banner-text">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>先进弯手机</h5>-->
<!--                <h5>控制技术</h5>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>可精准适配多类型锉型的往复角度</p>-->
<!--                <p>并快速切换 TorqueSense、</p>-->
<!--                <p>ATR 等运动模式</p>-->
<!--                <p>操作响应更迅速，也更贴合临床需求</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="improved-content" ref="improvedContentRef">-->
<!--          <div class="improved-content-container">-->
<!--            <div class="improved-content-title-info">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <h5>多重保护</h5>-->
<!--                  <h5>让根管预备更可控</h5>-->
<!--                  <h5>更安心</h5>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="improved-content-detail">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <h5>根尖动态预警：操作心中有数</h5>-->
<!--                </div>-->
<!--                <div class="product-special-title-p">-->
<!--                  <p>声光渐进提示：锉针接近根尖时，提示音由弱渐强，到达根尖LED指示灯同步闪烁提示，动态提示预备深度。</p>-->
<!--                  <p>动态轨迹监测：屏幕实时显示锉针在根管内的位置趋势，让操作一目了然。</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="improved-content-detail">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <h5>智能预设控制：多种自动辅助</h5>-->
<!--                </div>-->
<!--                <div class="product-special-title-p">-->
<!--                  <p>进出根管自动启停: 锉针进入根管自动运转，离开即停，简化手动操作。</p>-->
<!--                  <p>接近根尖自动减速：临近根尖报警点自动降低转速，便于医生从容操作。</p>-->
<!--                  <p>到达根尖智能响应：到达根尖报警点时可设置自动反转或自动停止，辅助医生避免过度预备。</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="contra-angle-container">-->
<!--        <div class="contra-angle-banner">-->
<!--          <div class="contra-angle-box">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260126/b6fae8e10d30f115833d98ad4ed608d9.png" alt=""/>-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>超薄</h5>-->
<!--                <h5>8 mm弯机头</h5>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>轻松进入后牙区</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="contra-angle-banner-text">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>LED手柄</h5>-->
<!--                <h5>可调冷光设计</h5>-->
<!--              </div>-->
<!--              <div class="flex contra-angle-parameter">-->
<!--                <div class="bottom-align">-->
<!--                  <div class="product-special-title-b">-->
<!--                    <h5 style="vertical-align: bottom;">≥8000</h5>-->
<!--                  </div>-->
<!--                  <div class="product-special-title-p">-->
<!--                    <p>lux</p>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash;                <div class="bottom-align">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="product-special-title-b">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <h5>8 mm</h5>&ndash;&gt;-->
<!--                &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="product-special-title-p">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <p>diameter</p>&ndash;&gt;-->
<!--                &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--              <div class="product-special-title-p contra-angle-desc">-->
<!--                <p>确保视野明亮无阴影</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="contra-angle-animation">-->
<!--          <div class="contra-angle-slider">-->
<!--            <i class="dark">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/791eea63527aa78c4a20687435031129.png" alt="">-->
<!--            </i>-->
<!--            <el-slider v-model="contraAngleSliderValue" :show-tooltip="false" :max="contraAngleBanner.length" @input="listenMove"></el-slider>-->
<!--            <i class="light">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/234999d86aa2515b99003560dc84cb3e.png" alt="">-->
<!--            </i>-->
<!--          </div>-->
<!--          <div class="contra-angle-animation-container">-->
<!--            <img ref="contraAngleAnimationRef" :src="contraAngleBanner[0]" alt="">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-build-file">-->
<!--        <div class="product-special-title">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>锉系统 自由掌控</h5>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="product-detail-text1"  style="text-align: center;">-->
<!--          <p class="txt">内置常用锉序列，开机即可使用，系统支持Wi-Fi软件在线升级</p>-->
<!--          <p class="txt">锉库可随软件同步更新，始终紧跟最新标准。直观界面支持自定义锉与锉序列</p>-->
<!--          <p class="txt">可按锉号、锥度、长度等参数创建专属锉型。也可将多品牌锉与自建锉组合为混合序列</p>-->
<!--          <p class="txt">无论预备通路、MB2 或宽大复杂根管皆可构建独立、针对性的操作方案</p>-->
<!--        </div>-->

<!--        <div class="build-file-video-container product-video-container">-->
<!--          <video class="build-file-video product-video"-->
<!--                 :ref="videoList[7].ref"-->
<!--                 :src="videoList[7].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--          ></video>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="selection-magnetic">-->
<!--        <div class="product-special-title">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>手柄与主机无线连接</h5>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="product-detail-text1"  style="text-align: center;">-->
<!--          <p class="txt">磁吸底座轻松对接</p>-->
<!--          <p class="txt">实现便捷的无接触充电</p>-->
<!--        </div>-->
<!--        <div class="section-product-desc">-->
<!--          <div class="magnetic-video-container product-video-container">-->

<!--            <div class="progress">-->
<!--              <circular-progress :progress="videoList[8].progress" :isPlaying="videoList[8].playing" index="8" @togglePlay="togglePlay"/>-->
<!--            </div>-->
<!--            <video class="magnetic-video product-video"-->
<!--                   :ref="videoList[8].ref"-->
<!--                   :src="videoList[8].video"-->
<!--                   muted-->
<!--                   playsinline-->
<!--                   loop-->
<!--            ></video>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-touch-screen">-->
<!--        <div class="touch-screen-list">-->
<!--          <div class="touch-screen-item">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>6 英寸</h5>-->
<!--                <h5>高清触控屏</h5>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/f055b846712d32b00ca5269fa5fa8cef.png" alt=""/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="touch-screen-item">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-detail-text1">-->
<!--                <p class="txt">在强光下依然清晰可见</p>-->
<!--                <p class="txt">可戴手套流畅操作</p>-->
<!--                <p class="txt">快捷预设提升临床效率</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/bc98871ecd2c3c870d358a7ff2f71fd5.png" alt=""/>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="section-packaging">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>可降解包装 减轻地球负担</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="product-detail-text1"  style="text-align: center;">-->
<!--            <p class="txt">我们持续减少塑料的使用。产品包装选用符合严苛环保标准的可生物降解材料，在满足产品保护与使用体验的同时，</p>-->
<!--            <p class="txt">尽量降低对环境的长期影响。</p>-->
<!--            <p class="txt">给地球的礼物，从一份会“消失”的包装开始。</p>-->
<!--          </div>-->

<!--          <div class="image">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/69f6de3ab94b8a658f9cfe0bff2a6bc6.jpg" alt=""></img>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="keep-exploring">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>GT全系列</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="keep-exploring-container">-->
<!--            <div class="mode-list">-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT mini</h5>-->
<!--                </div>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT</h5>-->
<!--                </div>-->
<!--                <p class="txt pl-145 fc">手柄内置根测</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT Pro</h5>-->
<!--                </div>-->
<!--                <p class="txt pl-132 fc">手柄内置根测</p>-->
<!--                <p class="txt pl-132 fc">主机内置根测</p>-->
<!--                <p class="txt pl-132 fc">无线脚踏</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line"></i>-->

<!--            <div class="mode-function mode-list">-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title pl-120">Endo GT Mini</p>-->
<!--                <p class="txt pl-120">6:1弯机头 * 2</p>-->
<!--                <p class="txt small pl-120">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4 pl-120">手柄 * 1</p>-->
<!--                <p class="txt pl-120">主机 * 1</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">电源适配器 * 1</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">充电底座 * 1</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">注油嘴 * 1</p>-->
<!--                <p class="txt pl-120">一次性保护套 * 10</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">说明书 * 1</p>-->
<!--                <p class="txt pl-120">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title pl-145">Endo GT</p>-->
<!--                <p class="txt pl-145">6:1弯机头 * 2</p>-->
<!--                <p class="txt small pl-145">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4 pl-145">手柄 * 1</p>-->
<!--                <p class="txt pl-145">主机 * 1</p>-->
<!--                <p class="txt pl-145">-</p>-->
<!--                <p class="txt pl-145">电源适配器 * 1</p>-->
<!--                <p class="txt pl-145">锉夹 * 4</p>-->
<!--                <p class="txt pl-145">唇钩 * 5</p>-->
<!--                <p class="txt pl-145">探针 * 2</p>-->
<!--                <p class="txt pl-145">充电底座 * 1</p>-->
<!--                <p class="txt pl-145">测量线 * 1</p>-->
<!--                <p class="txt pl-145">测试器 * 1</p>-->
<!--                <p class="txt pl-145">注油嘴 * 1</p>-->
<!--                <p class="txt pl-145">一次性保护套 * 10</p>-->
<!--                <p class="txt pl-145">硅胶保护套 * 2</p>-->
<!--                <p class="txt pl-145">说明书 * 1</p>-->
<!--                <p class="txt pl-145">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title pl-132">Endo GT Pro</p>-->
<!--                <p class="txt pl-132">6:1弯机头 * 2</p>-->
<!--                <p class="txt small pl-132">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4 pl-132">手柄 * 1</p>-->
<!--                <p class="txt pl-132">主机 * 1</p>-->
<!--                <p class="txt pl-132">无线脚踏 * 1</p>-->
<!--                <p class="txt pl-132">电源适配器 * 2</p>-->
<!--                <p class="txt pl-132">锉夹 * 4</p>-->
<!--                <p class="txt pl-132">唇钩 * 5</p>-->
<!--                <p class="txt pl-132">探针 * 2</p>-->
<!--                <p class="txt pl-132">充电底座 * 1</p>-->
<!--                <p class="txt pl-132">测量线 * 1</p>-->
<!--                <p class="txt pl-132">测试器 * 1</p>-->
<!--                <p class="txt pl-132">注油嘴 * 1</p>-->
<!--                <p class="txt pl-132">一次性保护套 * 10</p>-->
<!--                <p class="txt pl-132">硅胶保护套 * 2</p>-->
<!--                <p class="txt pl-132">说明书 * 1</p>-->
<!--                <p class="txt pl-132">装箱单 * 1</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line" style="margin-top: 53px;"></i>-->

<!--            <div class="specifications-container">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <h5>参数</h5>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="specifications-list ">-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">转速</p>-->
<!--                  <p class="title">Endo GT Pro:50-3100 r/min</p>-->
<!--                  <p class="title ml-120">Endo GT/Endo GT mini:50-3000 r/min</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">扭矩</p>-->
<!--                  <p class="title">0.4-5.0 N·cm</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">转速比</p>-->
<!--                  <p class="title">6:1</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">集成LED</p>-->
<!--                  <p class="title">≥8000 lux</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">模式</p>-->
<!--                  <p class="title">EAL, CW, CCW, REC (SGP), TorqueSense</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <video-modal ref="videoModalRef"></video-modal>-->
<!--    </div>-->
    <specialEndo ></specialEndo>

    <footers ref=is_change></footers>
  </div>
</template>

<script>

import headers from "@/common/header.vue";
import footers from "@/common/footers.vue";
import positionBar from "@/components/position-bar.vue";
// import circularProgress from "../components/endo/progress-circle.vue";
// import endoButton from '../components/endo/button.vue'
// import videoModal from '../components/endo/video-modal.vue'

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);
import specialEndo from "@/components/special/pc/endo/index.vue"

//
export default {
  components: {
    positionBar,
    footers,
    headers,
    specialEndo
    // circularProgress,
    // endoButton,
    // videoModal
  },
  data() {
    return {
      is_mounted: false,
      productc_nav: false,
      videoProgress: 0,
      videoIsPlaying: true,
      contraAngleSliderValue: 0,
      videoList: [
        {
          ref: 'previewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/796e824f5145403708972671759/oOkSHUvpaWoA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5b5a06b85145403713209442445/sIPEE86eV5IA.mp4',
        },
        {
          ref: 'productVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/473fa3e65145403709194452288/1J1BHLRNKowA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/56a834465145403714488171756/x2huXQ5iuEgA.mp4'
        },
        {
          ref: 'stepVideo1Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
        },
        {
          ref: 'stepVideo2Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
        },
        {
          ref: 'stepVideo3Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
        },
        {
          ref: 'gPreviewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/7e22f7285145403709306548865/CUggH2zVoPcA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/58c945285145403714488245774/kUesAPotdfcA.mp4'
        },
        {
          ref: 'gModeVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/a960dc375145403713224008980/hruOoezPeoUA.mp4'
        },
        {
          ref: 'buildFileVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fee05aaa5145403715045789494/DIyA9cfuckQA.mp4'
        },
        {
          ref: 'magneticRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/36843a685145403714294898054/bbSFtNG3RrwA.mp4'
        },
      ],
      contraAngleBanner: [
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c6067e872b55e5d6acf177939ac5a0c8.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/b59ba70340db05e588244f83f18a0f8e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/493cc727e1a9b5e616f29a2211ac7104.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/9ead80eb13be4a13f0f3cdc42285c9ff.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/72ce736cd62207015f96a91f83752ce6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/649aa3dd9b0219be20c02dbb3ea41cb4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/040fbcef9345317e6d5f8b63634507eb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/8238944342b81f5b8134ce2b715286e7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6d2c31c66743625370ef787fb2ec1b27.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/de71d210ca45ff166b222da3732253a6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ab90e7a6d3975e0a29c92cf0b6a31417.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/0c819732e2b2468b7fca309e559f25d0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/16a6ce0e7b967e2f87251c7bad80659e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d280151d0cb8197d4aa42a787c454db4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ec6e696ef61b2e74fd5180921dd96b63.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/e6d25395da38d05f2d50bb58f900e4ec.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/a1956fe4da20f7f1e849500bc86a33c7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/da1db807c80ef7d3cda11b17dba77314.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/afc00c7d7b782b7d0d89a67fd164c570.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/7fb5b76f81a3d809d1228a704bc74b20.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/debef22e218b390390be149c6ff5d2a0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/cb6940cd8b4f2b756961b647d2ac8e88.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c68e77cb7327bb6b434b16d420a86eca.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6e13e064ac62342482f6871cf419acfb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/413f3dbb1a3eea85c927879f1b952ef9.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d73bc851d358422a7fa81b61e8c3e8db.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/5d117257f053179f6f41ae8d2f60dab5.jpg',
      ],
      positionNav: [
        {
          title: 'Endo GT Series',
          path: '/pc/special/endo'
        },
      ],
      moveStart: true,
      improvedBannerTop: 0,
      isImprovedContainerRef: false
    };
  },
  mounted() {
    let that = this
    this.$nextTick(() => {
      this.is_mounted = true

      this.addSliderHoverListener();
      document.addEventListener('scroll', this.handleScroll, false)

      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('scroll', this.handleScroll, false)
      })
    })
  },
  created() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      // this.$router.push({ path: '/ph/special/endo', query: this.$route.query })
    }
  },
  methods: {
    addSliderHoverListener() {
      this.$nextTick(() => {
        const sliderButtonWrapper = document.querySelector('.el-slider__button-wrapper');

        if (sliderButtonWrapper) {
          sliderButtonWrapper.addEventListener('mouseenter', this.onSliderMouseEnter);
          sliderButtonWrapper.addEventListener('mouseleave', this.onSliderMouseLeave);
          this.contraAngleBannerMove()
        }
      });
    },
    onSliderMouseEnter() {
      this.moveStart = false
    },

    onSliderMouseLeave() {
      this.moveStart = true
    },
    removeSliderHoverListener() {
      const sliderButtonWrapper = document.querySelector('.el-slider__button-wrapper');

      if (sliderButtonWrapper) {
        sliderButtonWrapper.removeEventListener('mouseenter', this.onSliderMouseEnter);
        sliderButtonWrapper.removeEventListener('mouseleave', this.onSliderMouseLeave);
      }
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
    listenMove(value){
      if(value < this.contraAngleBanner.length){
        this.$refs.contraAngleAnimationRef.src = this.contraAngleBanner[value]
      }
    },
    contraAngleBannerMove(){
      if(this.moveStart){
        if(this.contraAngleSliderValue >= (this.contraAngleBanner.length - 1)){
          this.contraAngleSliderValue = 0
        }
        this.contraAngleSliderValue++
      }
      setTimeout(() => {
        this.contraAngleBannerMove()
      }, 500)
    },
    togglePlay(index) {
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[this.videoList[index].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
      }else {
        this.$refs[this.videoList[index].ref].pause();
      }
    },
    onImageLoad(){
      this.initScrollAnimation();
    },
    onModeVideoLoaded(){
      // this.initImprovedBannerAnimation()
    },
    onImprovedBanner(){
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.initImprovedBannerAnimation()
      //   }, 500)
      // })
      this.initImprovedBannerPosition()
    },
    initImprovedBannerPosition(){
      const imgElement = document.querySelector('.special-main .special-body .improved-container .improved-banner img');
      if (imgElement) {
        const height = imgElement.offsetHeight;
        let space = window.innerHeight - height
        let top = 0

        if(space < 0){
          top = Math.abs(space) - 1
          // if(top > 310){
          //   top = 310
          // }
        }
        this.improvedBannerTop = top
      }

    },
    initImprovedBannerAnimation(){
      gsap.timeline({
        scrollTrigger: {
          trigger: ".improved-container",
          start: `top top`,
          end: `+=1000`,
          scrub: true,
          pin: true,
          onEnter: () => {
          },
        }
      }).to('.improved-banner-text', {
        opacity: 0
      })
          .to('.improved-background', {
            opacity: 1,
          }, '<')
          .to('.improved-content',{
            y: `-100vh`
          }, '<')
    },
    initScrollAnimation(){
      const _this = this

      const bannerElement = document.querySelector('.banner')

      this.videoList.forEach(item => {
        if(this.$refs[item.ref]){
          this.$refs[item.ref].addEventListener('timeupdate', this.onVideoProgress);
        }
      })
      this.setupVideoIntersectionObserver()

      gsap.timeline({
        scrollTrigger: {
          trigger: ".banner-container",
          start: `top top`,
          end: `+=2000`,
          scrub: true,
          pin: true,
          onEnter: () => {
            if (this.$refs[this.videoList[0].ref]) {
              this.$refs[this.videoList[0].ref].currentTime = 0;
              this.videoList[0].playing = true
              this.$refs[this.videoList[0].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
            }
          },
        }
      }).to(this.$refs.previewVideoContainerRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoTextRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoBoxRef, {
        background: 'rgba(0, 0, 0, 0)'
      }, "<")
    },
    setupVideoIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && !this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].play().catch(() => {});
              this.videoList[index].playing = true;
            }
          }else {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].pause();
              this.$refs[this.videoList[index].ref].currentTime = 0
              this.videoList[index].playing = false;
            }
          }
          // if (entry.intersectionRatio === 0) {
          //   this.videoList.forEach(item => {
          //     if (this.$refs[item.ref] === entry.target) {
          //       this.$refs[item.ref].pause();
          //       this.$refs[item.ref].currentTime = 0;
          //       item.playing = false;
          //     }
          //   });
          // } else if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          //   this.videoList.forEach(item => {
          //     if (this.$refs[item.ref] === entry.target) {
          //       this.$refs[item.ref].play().catch(e => console.log(item.ref + "视频播放失败:", e));
          //       item.playing = true;
          //     }
          //   });
          // }
          if(this.$refs.improvedContainerRef == entry.target && entry.intersectionRatio >= 0.1 && !this.isImprovedContainerRef){
            this.isImprovedContainerRef = true
            this.initImprovedBannerAnimation()
          }

        });
      }, {
        threshold: [0, 0.1, 0.5, 1.0],
        rootMargin: '0px'
      });

      this.videoList.forEach(item => {
        if (this.$refs[item.ref]) {
          observer.observe(this.$refs[item.ref]);
        }
      });
      observer.observe(this.$refs.improvedContainerRef);

      this.$once('hook:beforeDestroy', () => {
        observer.unobserve(this.$refs.improvedContainerRef);
        this.videoList.forEach(item => {
          if (this.$refs[item.ref]) {
            observer.unobserve(this.$refs[item.ref]);
          }
        });
      });
    },
    onVideoProgress(event) {
      const video = event.target;
      const currentTime = video.currentTime;
      const duration = video.duration;

      const videoIndex = this.videoList.findIndex(item => {
        return this.$refs[item.ref] === video;
      });

      if (videoIndex !== -1) {
        this.videoList[videoIndex].progress = ((currentTime / duration) * 100).toFixed(2);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    ChangeEmit(){
      this.$refs.is_change.get_index_channel_data();
      this.$refs.is_change.pageParam();
    },
  },
  beforeDestroy() {
    this.removeSliderHoverListener();
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
};
</script>

<style >

</style>
